import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { endPoints } from '../../Config';
import { handleGetRequest } from '../../service/GetTemplate';
import { useLocation, useNavigate } from 'react-router-dom';

const ViewTicket = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [ticketStatus, setTicketStatus] = useState([]);
    const [ticketDetails, setTicketDetails] = useState([]);
    const [thread, setThread] = useState([]);

    const location = useLocation();
    const { rowData } = location.state || {};

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            TransactionId: '',
            TicketTypeId: '',
            Title: '',
            Message: '',
            Files: ''
        }
    });

    const getTicketStatus = async () => {
        const response = await handleGetRequest(endPoints.getDropdownTicketsStatus, true, false, dispatch);
        if (response) {
            setTicketStatus(response?.data);
        }
    };

    useEffect(() => {
        getTicketStatus();
    }, []);

    const getTicketById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getTicketById(rowData.id), true);
        if (response) {
            setTicketDetails(response?.data?.ticketDetails);
            setThread(response?.data?.threads);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (rowData) {
            getTicketById();
        }
    }, [rowData]);

    const createdDateTemplate = (rowData) => {
        const isoDate = rowData?.createdAt;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();

        const formattedDate = `${dd}/${mm}/${yyyy}`;
        return <p>{formattedDate}</p>;
    };

    return (
        <div className="p-4">
            <div className="card Card__Round">
                <div className="p-fluid p-formgrid grid mb-5">
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket ID
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.id}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Status
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.ticketStatus}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Type
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.ticketType}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Title
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.title}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Message
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.message}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={thread}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="threadId" header="ID " />
                            <Column body={createdDateTemplate} header="Created On" />
                            <Column field="createdBy" header="Created By" />
                            <Column field="threadStatus" header="Status" />
                            <Column field="threadMessage" header="Message" />
                        </DataTable>
                    </div>
                </div>
            </div>
            <div className="flex justify-content-center mt-4 gap-2">
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/tickets')} />
            </div>
        </div>
    );
};

export default ViewTicket;
